import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
//let serverUrl = ("http://localhost:3000")
import i18n from '@plugins/i18n'

export const getters = {
  getCategoryFields() {
    return {
      model: 'repositories_category',
      label: 'Categories',
      fields: [
        { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
        { key: 'description', label: 'Description', type: 'text', sortable: true, required: false }
      ]
    }
  },
}

export const actions = {
  async fetchCategories(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/categories/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async fetchCategoriesFilter(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/categories/listForFilters`)
      .then((response) => {
        return response.data;
      })
  },


  async createCategories(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/categories/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateCategories(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/categories/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteCategories(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/categories/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}